import {Fragment, h} from "preact";
import s from "../product.module.css";
import {useAppContext} from "../../../../../../../contexts";

const ProductActions = (props) => {
    // Destructured props
    const {
        updateCart,
        item,
        incrementDisable
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={"flex flex-col justify-between items-center gap-y-1.5"}>
                <div className={"flex flex-row justify-between items-center"}>
                    <button
                        className={`${s.leftActionButton} ${highContrast ? "highFormButtonSecond" : ""}`}
                        onClick={() => updateCart({
                            item,
                            action: "DECREMENT"
                        })}
                    >
                        -
                    </button>
                    <p className={`${s.itemsAmount} ${highContrast ? "highFormButtonSecond" : ""}`}>
                        {item.qty}
                    </p>
                    <button
                        className={`
                            ${s.rightActionButton} 
                            ${incrementDisable ? s.disabledRightAction : ""}
                            ${highContrast
                            ? `${incrementDisable ? "highButton" : "highFormButtonSecond"}`
                            : ""
                        }
                        `}
                        onClick={() => updateCart({
                            item,
                            action: "INCREMENT"
                        })}
                        disabled={incrementDisable}
                    >
                        +
                    </button>
                </div>
                <button
                    className={s.deleteButton}
                    onClick={() => updateCart({
                        item,
                        action: "DELETE"
                    })}
                >
                    Excluir
                </button>
            </div>
        </Fragment>
    )
}

export default ProductActions;
